import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import CounterUp1 from "./CounterUp1";

const CounterUpTwo = () => {
  const [paddingStyle, setPaddingStyle] = useState({
    padding: "100px 0 70px", // default desktop padding
  });

  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1023) {
        // tablet and below
        setPaddingStyle({ padding: "40px 0 30px" });
      } else {
        // desktop
        setPaddingStyle({ padding: "100px 0 70px" });
      }
    };

    handleResize(); // set initial value
    window.addEventListener("resize", handleResize); // listen for resize
    return () => window.removeEventListener("resize", handleResize); // cleanup
  }, []);

  const handleContactClick = (e) => {
    if (location.pathname === "/contact-us") {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    // Otherwise, the default Link behavior will handle navigation
  };

  return (
    <div
      className="section section-padding expert-counterup-area"
      style={paddingStyle}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5">
            <div className="section-heading heading-left">
              <span className="subtitle1">Experts in field</span>
              <h2>What makes us special?</h2>
              <p className="mb--50">
                At UCWF, we distinguish ourselves through our dedication to
                excellence, innovation, and personalized service. Our skilled
                team provides comprehensive facility management solutions
                tailored to your specific needs. We prioritize quality,
                sustainability, and efficiency to ensure smooth operations and
                increased property value. By leveraging proactive maintenance,
                advanced technology, and a commitment to customer satisfaction,
                we create safe, clean, and productive environments for our
                clients.
              </p>
              <Link
                to={process.env.PUBLIC_URL + "/contact-us"}
                className="axil-btn btn-large btn-fill-primary d-block d-sm-inline-block mx-auto mx-sm-0"
                onClick={handleContactClick}
              >
                Contact us
              </Link>
            </div>
          </div>
          <div className="col-lg-6 offset-xl-1">
            <div className="row">
              <CounterUp1
                colSize="col-sm-6"
                layoutStyle="counterup-style-2"
                evenTopMargin=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CounterUpTwo;
